<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'REGISTRATION_SUCCESSFUL' | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body p-0">
  <div class="row mx-0">
    <div class="col-md-12 p-4">
      @if (type === 'registerSale') {
        <ngb-alert type="success" [dismissible]="false">{{'REGISTER_SALE_SUCCESSFUL'|translate}}</ngb-alert>
      }
      @if (type === 'registerSalePrepare') {
        <ngb-alert type="success" [dismissible]="false">{{'EBIKE_PREPARED_FOR_USE'|translate}}</ngb-alert>
      }
      @if (type === 'ezyRider') {
        <ngb-alert type="success" [dismissible]="false">{{'XTRA_REGISTERED'|translate}}</ngb-alert>
      }
      @if (type === 'service') {
        <ngb-alert type="success" [dismissible]="false">{{'REGISTER_SERVICE_SUCCESSFUL'|translate}}</ngb-alert>
      }
      @if (pdfSrc) {
        <button class="btn btn-success btn-lg mb-2 d-block" (click)="downloadPdf()"
        >{{'DOWNLOAD'|translate}} PDF</button>
      }
      @if (type === 'registerSalePrepare' || type === 'ezyRider') {
        <div class="scrollable customScrollbar pdfContainer d-block overflow-auto" style="max-height: 60vh"
          >
          @if (loading) {
            <div class="m-2 spinner-border text-primary spinner-border" role="status">
              <span class="visually-hidden">{{'LOADING'|translate}}</span>
            </div>
          }
          @if (pdfSrc) {
            <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"
              class="border d-block w-100">
            </pdf-viewer>
          }
        </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <span class="col-md-12 p-0">
    <button class="btn btn-dark " (click)="modal.dismiss('cancel click')">{{'CLOSE' | translate}}</button>
  </span>
</div>
